import { render, staticRenderFns } from "./roleUpdate.vue?vue&type=template&id=3225ff95&scoped=true&"
import script from "./roleUpdate.vue?vue&type=script&lang=js&"
export * from "./roleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./roleUpdate.vue?vue&type=style&index=0&id=3225ff95&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225ff95",
  null
  
)

export default component.exports